// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"c3294fa7","1177":"1e16e5b8","2969":"1e16e5b8","5979":"c3294fa7","7220":"559c4ee1"}[chunkId] + ".chunk.css";
};